import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListDocumentRequest extends IBaseRequest {
    limit?:        string;
    offset?:       string;
    parent?:       string;
    orderBy?:      string;
    id?:           string;
    acl?:          string;
    countOnly?:    string;
    typeId?:       string;
    type?:         string;
    categoryId?:   string;
    category?:     string;
    deepSearch?:   string;
    PRIORITIES?:   string[];
    RESTRICTIONS?: string[];
}

export class ListDocumentRequest extends BaseRequest implements IListDocumentRequest {

    public limit?:        string = '';
    public offset?:       string = '';
    public parent?:       string = '';
    public orderBy?:      string = '';
    public id?:           string = '';
    public acl?:          string = '';
    public countOnly?:    string = '';
    public typeId?:       string = '';
    public type?:         string = '';
    public categoryId?:   string = '';
    public category?:     string = '';
    public deepSearch?:   string = '';
    public PRIORITIES?:   string[] = [];
    public RESTRICTIONS?: string[] = [];

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.limit = otherOptions.limit;
        this.offset = otherOptions.offset;
        this.parent = otherOptions.parent;
        this.orderBy = otherOptions.orderBy;
        this.id = otherOptions.id;
        this.acl = otherOptions.acl;
        this.countOnly = otherOptions.countOnly;
        this.typeId = otherOptions.typeId;
        this.type = otherOptions.type;
        this.categoryId = otherOptions.categoryId;
        this.category = otherOptions.category;
        this.deepSearch = otherOptions.deepSearch;
        this.PRIORITIES = otherOptions.PRIORITIES;
        this.RESTRICTIONS = otherOptions.RESTRICTIONS;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.parent, 'parent');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.acl, 'acl');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.typeId, 'typeId');
        parameters += this.makeNode(this.type, 'type');
        parameters += this.makeNode(this.categoryId, 'categoryId');
        parameters += this.makeNode(this.category, 'category');
        parameters += this.makeNode(this.deepSearch, 'deepSearch');
        parameters += this.PRIORITIES?.map((priority) => this.makeNode(priority, 'PRIORITIES')).join('') || '';
        parameters += this.RESTRICTIONS?.map((restriction) => this.makeNode(restriction, 'RESTRICTIONS')).join('') || '';
        
        return super.wrapperXml('ListDocument', parameters);
    }
}
